export const phrases: string[] = [
    'LIBERA TU POTENCIAL',
    'ENCUENTRA TU DESTINO',
    'DESCUBRE TU MAGIA',
    'VIVE POSITIVAMENTE',
    'APRENDE A SANARTE',
    'CREE EN TI Y TODO SERA POSIBLE',
    'SI PUEDES SOÑARLO, PUEDES LOGRARLO',
    'TU ACTITUD DETERMINA TUS RESULTADOS',
    'LOS LIMITES SOLO EXISTEN EN TU MENTE',
    'SI NO OCURRE, TAMBIÉN ES UNA SEÑAL',
    'PREOCUPATE MENOS Y SONRIE MÁS',
    'LO QUE ES PARA TI, SIEMPRE ENCUENTRA EL CAMINO',
    'A VECES PERDER ES GANAR LIBERTAD',
    'EL DÍA QUE DEJES DE ESPERAR, LLEGA LO QUE MERECES',
    'LO QUE NO SUMA, ENSEÑA',
    'RESPIRA, CONFÍA Y SUELTA',
    'DONDE HAY PAZ, AHÍ ES',
    'EL SILENCIO TAMBIÉN RESPONDE',
    'LO QUE ES... FLUYE',
    'ELIGE SIEMPRE LA PAZ',
    'SIN PRISA, PERO SIN PAUSA',
    'MENOS MENTE, MÁS ALMA',
]
